
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IMemberWithoutBarometerHypermediaRepresentation } from '../../shared/contracts/MemberContract';
import BounceInTransition from '../shared/BounceInTransition.vue';

@Component({
    components: {
        BounceInTransition
    }
})
export default class MembersWithoutBarometerCollection extends Vue {
    @Prop() members!: IMemberWithoutBarometerHypermediaRepresentation[];
}
